export default {
  formId: "Contractor-creation",
  formField: {
    firstName: {
      name: "firstName",
      label: "First Name",
      type: "text",
      errorMsg: "First name is required.",
      invalidMsg: "First name is invalid",
    },
    lastName: {
      name: "lastName",
      label: "Last Name",
      type: "text",
      errorMsg: "Last name is required.",
      invalidMsg: "Last name is invalid",
    },
    email: {
      name: "email",
      label: "Email",
      type: "email",
      errorMsg: "Email is required.",
      invalidMsg: "Email is invalid",
    },
    code: {
      name: "code",
      label: "Employee number",
      type: "text",
      disabled: true,
      errorMsg: "Employee number is required.",
      invalidMsg: "Employee number  is invalid",
    },
    ssn: {
      name: "ssn",
      label: "SSN",
      type: "text",
      errorMsg: "SSN is required.",
      invalidMsg: "SSN  is invalid",
    },
    subCompany: {
      name: "subCompany",
      label: "Company",
      type: "select",
      errorMsg: "Company is required.",
      invalidMsg: "Company is not valid",
    },
    location: {
      name: "location",
      label: "Location",
      type: "select",
      errorMsg: "location is required.",
      invalidMsg: "Location is not valid",
    },
    job: {
      name: "job",
      label: "Job",
      type: "select",
      errorMsg: "job is required.",
      invalidMsg: "job is not valid",
    },
    rate: {
      name: "rate",
      label: "Rate",
      type: "number",
      errorMsg: "Rate is required.",
      invalidMsg: "Rate is invalid",
    },
    workPhoneNumber: {
      name: "workPhoneNumber",
      label: "Phone Number",
      type: "phoneNumber",
      errorMsg: "Phone number is required.",
      invalidMsg: "Your phone number is invalid",
    },
    typeCode: {
      name: "typeCode",
      label: "Type",
      type: "select",
      errorMsg: "Type is required.",
      invalidMsg: "Type is not valid",
    },
    status: {
      name: "status",
      label: "Status",
      type: "select",
      errorMsg: "Status is required.",
      invalidMsg: "Status is not valid",
    },
  },
};
